import script from "./UpgradePromptModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./UpgradePromptModal.vue?vue&type=script&lang=ts&setup=true"

import "./UpgradePromptModal.vue?vue&type=style&index=0&id=f0e086b0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f0e086b0"]])

export default __exports__